import React from 'react';
import { NAV_SECTIONS } from './data';

export const SectionNav = ({ activeSection }) => (
  <div className="sticky top-16 md:top-20 z-40 bg-black/90 backdrop-blur-md border-b border-[#e8ff00]/10" data-testid="hyrox-section-nav">
    <div className="container-ninja">
      <div className="flex gap-1 overflow-x-auto py-2 scrollbar-hide">
        {NAV_SECTIONS.map((s) => (
          <a
            key={s.id}
            href={`#${s.id}`}
            className={`px-4 py-2 text-xs uppercase tracking-wider font-heading whitespace-nowrap transition-all ${
              activeSection === s.id ? 'text-[#e8ff00] bg-[#e8ff00]/10 border border-[#e8ff00]/30' : 'text-zinc-500 hover:text-white border border-transparent'
            }`}
            data-testid={`hyrox-nav-${s.id}`}
          >
            {s.label}
          </a>
        ))}
      </div>
    </div>
  </div>
);
